<template>
  <review-layout class="page-video-program-detail"
                 :program-id="program.id"
                 :show-bottom-bar="showBottomBar"
                 :reply-review="replyReview"
                 :reviews="reviews"
  >
    <div class="video-program-detail-component">
      <program-header :program="program"
                      :audio="audio"
                      :programs="programs"
                      :join-btn="render.joinBtn"
                      :group-buy="groupBuy"
                      :sell="audio.sell"
      />

      <program-content :program-id="program.id"
                       :reviews="reviews"
                       :is-member="isMember"
                       :render="render"
                       :tab-active.sync="tabSelected"
                       @click-join="showAudioDetail"
                       @reply="handleClickReply"
      />
    </div>
  </review-layout>
</template>

<script>
  import { mapActions } from 'vuex';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import ReviewLayout from '@/pages/AudioProgram/components/ReviewLayout';
  import ProgramHeader from '@/pages/VideoProgram/components/VideoProgramDetailHeader';
  import ProgramContent from '@/pages/VideoProgram/components/VideoProgramDetailContent';
  import { isMobileWeb } from '@/utils';
  import { getProgramDetail } from '@/services/program';

  export default {
    name: 'VideoProgramDetail',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      ReviewLayout,
      ProgramHeader,
      ProgramContent,
    },
    data() {
      return {
        isMobileWeb: isMobileWeb(),

        tabSelected: 'material',
        replyReview: null,

        audio: {
          id: 0,
          type: '',
          title: '',
          price: 0,
          isMember: false,
          joinStatus: '',
          sell: {
            startTime: '',
            status: '',
          },
          update: {
            count: 0,
            status: 'updating',
          },
        },

        program: {
          id: 0,
          seq: 0,
          title: '',
          cover: require('@/assets/img/default/loading.gif'), // eslint-disable-line global-require
          summary: '',
          content: '',
          mediaType: '',
          src: [],
          pushTime: '',
          duration: '00:00',
          nextProgramId: 0,
          prevProgramId: 0,
        },

        programs: [],

        reviews: {
          list: [],
          start: 0,
          count: 0,
        },

        groupBuy: null,

        render: {
          joinBtn: {
            show: false,
            hint: '',
            price: {
              value: 0,
              delete: 0,
            },
          },
          content: null,
        },

        navBarList: [
          {
            name: '详情',
            type: 'detail',
            show: true,
          },
          {
            name: '资料',
            type: 'material',
            show: true,
          },
        ],
        showDownloadTips: false,

      };
    },
    computed: {
      isMember() {
        const { audio } = this;
        const { joinStatus } = audio;
        return joinStatus === 'member' || joinStatus === 'vipMember';
      },
      showBottomBar() {
        const { isMember, tabSelected } = this;
        return isMember && tabSelected === 'review';
      },
    },
    watch: {
      render(val) {
        this.setTabSelected(val);
      },
      $route(val) {
        this.initPageData(val.params.id);
      },
    },
    methods: {
      ...mapActions([
        'toggleVideoPlaylist',
      ]),
      async getProgramDetail(id) {
        const data = await getProgramDetail(id);

        this.audio = data.audio;

        this.benefit = data.benefit;

        this.program = data.program;
        this.program.audioId = this.audio.id;

        this.reviews = data.reviews;

        this.groupBuy = data.groupBuy;

        this.render = data.render;
      },
      async initPlayer(id) {
        const sort = this.getGlobalPlayerSort();
        const list = await this.fetchRealPlaylist(id, sort);
        this.programs = this.isMember ? list : list.filter(item => item.trialLength === -1);
        const generatedPlaylist = this.generateGlobalPlayerPlaylist(this.programs);
        this.toggleVideoPlaylist(generatedPlaylist);
      },
      setTabSelected(render) {
        if (render == null) return 'review';
        const { content } = render;
        if (content == null) return 'review';
        return 'material';
      },
      handleClickReply(review) {
        this.replyReview = review;
      },
      showAudioDetail() {
        const route = { name: 'AudioDetail', params: { id: this.audio.id } };
        this.$router.push(route);
      },
      initPageData(id) {
        this.initPlayer(id);
        this.getProgramDetail(id);
      },
    },
    created() {
      this.setTabSelected(this.render);
      const { params } = this.$route;
      const { id } = params;
      this.initPageData(id);
    },
    beforeRouteUpdate(to, from, next) {
      this.setTabSelected(this.render);
      const { params } = to;
      const { id } = params;
      this.initPageData(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-video-program-detail {
    min-height: 100%;
    background-color: @color-white;
  }

  .video-program-detail-component {
    background-color: @background-color-lightest;
  }
</style>
